import { INewrelicBrowserAgent } from "types/types";

export const useNewRelicBrowserAgent = () => {
  return (window as any).newrelic as INewrelicBrowserAgent | undefined;
};

export default useNewRelicBrowserAgent;
